import { REDUCER } from '../reducers/reducersConst';

export let setCourseId = courseId => {
  return {
    type: REDUCER.GOOGLE_CLASSROOM.SET_COURSE_ID,
    courseId
  };
};

export let clearCourseId = () => {
  return {
    type: REDUCER.GOOGLE_CLASSROOM.CLEAR_COURSE_ID
  };
};

export let setContent = (content, contentType) => {
  return {
    type: REDUCER.GOOGLE_CLASSROOM.SET_CONTENT,
    content,
    contentType
  };
};

export let clearContent = () => {
  return {
    type: REDUCER.GOOGLE_CLASSROOM.CLEAR_CONTENT
  };
};
